import { Typography } from 'antd'
import PropTypes from 'prop-types'
import { styled } from 'styled-components'

const { Paragraph } = Typography

export const Copyable = ({ text, alwaysShowIcon = false }) => (
  <ModifiedParagraph $alwaysShowIcon={alwaysShowIcon} copyable ellipsis={{ tooltip: text }}>{text}</ModifiedParagraph>
)

const ModifiedParagraph = styled(Paragraph)`
  &:hover {
    .ant-typography-copy {
      visibility: visible;
    }
  }

  width: 100px;

  margin-bottom: 0 !important;

  .ant-typography-copy {
    visibility: ${({ $alwaysShowIcon }) => $alwaysShowIcon ? 'visible' : 'hidden'};
  }
`

Copyable.propTypes = {
  alwaysShowIcon: PropTypes.bool,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
}

export default Copyable
